import './App.css';
import React, {useEffect, useState} from "react";
import ChoiceComponent from "./Pages/ChoiceComponent/ChoiceComponent";
import NavBar from "./Pages/Static/NavBar/NavBar";
import ConstructorPage from "./Pages/ConstructorPage/ConstructorPage";
import GamePageComponent from "./Pages/GamePage/GamePage.component";

function App() {
  const [point, setPoint] = useState('home')
  useEffect(()=>{

  },[])
  let Component

    switch (point) {
      case "home":
        Component = <ChoiceComponent point={point} setPoint={setPoint}/>
        break
       case 'game':
         Component = <GamePageComponent />
         break
      case 'constructor':
        Component =<ConstructorPage />
        break
    }


  return (
    <div className="App">
        <NavBar setPoint={setPoint}/>
      {Component}
    </div>
  )

}

export default App;
